import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ConfigProvider, App as AntApp } from 'antd';
import { datadogRum } from '@datadog/browser-rum';

import env from 'env';

import App from './App';
import 'normalize.css';
import './styles/_index.scss';

import { antdTheme } from 'styles/antd-theme';
import reportWebVitals from './reportWebVitals';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

process.env.NODE_ENV !== 'development' &&
  datadogRum.init({
    applicationId: env.DATADOG_APP_ID!,
    clientToken: env.DATADOG_CLIENT_TOKEN!,
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: 'datadoghq.com',
    service: env.DATADOG_SERVICE || 'survey-non-prod',
    env: env.DATADOG_ENV,
    // Specify a version number to identify the deployed version of your application in Datadog
    version: env.DATADOG_BUILD_VERSION,
    sessionSampleRate: env.DATADOG_SESSION_SAMPLE_RATE || 100,
    sessionReplaySampleRate: env.DATADOG_SESSION_REPLAY_SAMPLE_RATE || 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
  });

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <ConfigProvider theme={antdTheme}>
          <AntApp component={false}>
            <App />
          </AntApp>
        </ConfigProvider>
      </QueryClientProvider>
    </HelmetProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
